<div class="line"></div>
<div class="ball" [ngClass]="{'selected': (idx + 1) == currentStep}" *ngFor="let step of iterable; let idx = index">
    {{idx + 1}}
</div>